import { render, staticRenderFns } from "./label.vue?vue&type=template&id=de8b9e46&scoped=true"
import script from "./label.vue?vue&type=script&lang=js"
export * from "./label.vue?vue&type=script&lang=js"
import style0 from "./label.vue?vue&type=style&index=0&id=de8b9e46&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8b9e46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de8b9e46')) {
      api.createRecord('de8b9e46', component.options)
    } else {
      api.reload('de8b9e46', component.options)
    }
    module.hot.accept("./label.vue?vue&type=template&id=de8b9e46&scoped=true", function () {
      api.rerender('de8b9e46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/components/label.vue"
export default component.exports